import { React } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { ModalContainer } from '../common/ModalContainer';
import { ActionButton } from '../common/petCloud/ActionButton';

import styles from './EditWarningModal.module.css';

const EditWarningModal = ({
  handleProceed = () => { },
  isOpen = false,
  nextPeriodNumber = '',
  onClose = () => { },
}) => {
  const { t } = useTranslation('petDemos');

  return (
    <ModalContainer
      cancelable
      contentStyle={styles.modalCard}
      handleOutClick={onClose}
      id="reviewPetRollover"
      show={isOpen}
    >
      <div className={styles.container}>
        <h3>{t('policyInformation.warningEditModal.title')}</h3>

        <div className={styles.description}>
          <Trans
            components={{ bold: <span className={styles.bold} /> }}
            i18nKey="policyInformation.warningEditModal.description"
            ns="petDemos"
            values={{ nextPeriodNumber }}
          />
        </div>

        <div className={styles.buttonsRow}>
          <ActionButton
            noMargin
            onClick={handleProceed}
            title={t('policyInformation.warningEditModal.proceedToEdit')}
          />

          <ActionButton
            className={styles.cancelButton}
            isSecondaryButton
            noMargin
            onClick={onClose}
            title={t('policyInformation.warningEditModal.cancel')}
          />
        </div>
      </div>
    </ModalContainer>
  );
};

export { EditWarningModal };
